/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';

/**
 * 
 * @export
 * @interface Message
 */
export interface Message {
    /**
     * 
     * @type {number}
     * @memberof Message
     */
    id: number;
    /**
     * 
     * @type {User}
     * @memberof Message
     */
    authorId: User;
    /**
     * Related Document Model
     * @type {string}
     * @memberof Message
     */
    model: string;
    /**
     * Name of the related document
     * @type {string}
     * @memberof Message
     */
    recordName: string;
    /**
     * Related Document ID
     * @type {number}
     * @memberof Message
     */
    resId: number;
    /**
     * 
     * @type {Date}
     * @memberof Message
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    subject: string;
    /**
     * Message body in HTML
     * @type {string}
     * @memberof Message
     */
    body: string;
}

/**
 * Check if a given object implements the Message interface.
 */
export function instanceOfMessage(value: object): value is Message {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('authorId' in value) || value['authorId'] === undefined) return false;
    if (!('model' in value) || value['model'] === undefined) return false;
    if (!('recordName' in value) || value['recordName'] === undefined) return false;
    if (!('resId' in value) || value['resId'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    if (!('body' in value) || value['body'] === undefined) return false;
    return true;
}

export function MessageFromJSON(json: any): Message {
    return MessageFromJSONTyped(json, false);
}

export function MessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): Message {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'authorId': UserFromJSON(json['author_id']),
        'model': json['model'],
        'recordName': json['record_name'],
        'resId': json['res_id'],
        'date': (new Date(json['date'])),
        'subject': json['subject'],
        'body': json['body'],
    };
}

export function MessageToJSON(json: any): Message {
    return MessageToJSONTyped(json, false);
}

export function MessageToJSONTyped(value?: Message | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'author_id': UserToJSON(value['authorId']),
        'model': value['model'],
        'record_name': value['recordName'],
        'res_id': value['resId'],
        'date': value['date'].toISOString(),
        'subject': value['subject'],
        'body': value['body'],
    };
}

